import { ArrowRight } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";
import { cn as classJoin } from "../../lib/utils";

export default function DropOffPanel({ title, items, columns, accent, testid, openDrillDown }) {
    return (
        <div className="reedos-card overflow-hidden" data-testid={testid}>
            <div className="px-5 py-3 border-b border-slate-200 flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                    {accent}
                    <div>
                        <div className="reedos-eyebrow">{title}</div>
                        <div className="font-display text-base font-semibold text-slate-900">
                            {items.length} {items.length === 1 ? "deal" : "deals"}
                        </div>
                    </div>
                </div>
                {items.length > 0 && (
                    <Button variant="outline" size="sm" onClick={openDrillDown} className="text-xs gap-1" data-testid={`${testid}-drill-btn`}>
                        View all <ArrowRight size={11} weight="bold" />
                    </Button>
                )}
            </div>
            {items.length === 0 ? (
                <div className="px-5 py-6 text-center text-xs text-slate-500">All clear — no drop-off here.</div>
            ) : (
                <table className="w-full text-sm">
                    <thead className="bg-slate-50 border-b border-slate-200">
                        <tr className="text-left">
                            {columns.map((c) => (
                                <th key={c.key} className={classJoin("px-4 py-2 reedos-eyebrow", c.align === "right" && "text-right")}>{c.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {items.slice(0, 5).map((row) => (
                            <tr key={row.id} className="border-t border-slate-100 reedos-row-hover">
                                {columns.map((c) => (
                                    <td key={c.key} className={classJoin("px-4 py-2 text-xs", c.align === "right" && "text-right reedos-data")}>
                                        {c.render ? c.render(row) : row[c.key] || "—"}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
